import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { PortfolioPage } from './pages/PortfolioPage'
import { EngagementsPage } from './pages/EngagementsPage'
import { GalleryPage } from './pages/GalleryPage'
import { AboutPage } from './pages/AboutPage'
import { ContactPage } from './pages/ContactPage'
import { QuotePage } from './pages/QuotePage'
import { PackagesPage } from './pages/PackagesPage'
import { RavesPage } from './pages/RavesPage'
import { WeddingVenuesPage } from './pages/WeddingVenuesPage'
import { WeddingDressesPage } from './pages/WeddingDressesPage'
import './App.css'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/portfolio" element={<PortfolioPage />} />
          <Route path="/portfolio/engagements" element={<EngagementsPage />} />
          <Route path="/gallery/:galleryId" element={<GalleryPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/raves" element={<RavesPage />} />
          <Route path="/wedding-venues" element={<WeddingVenuesPage />} />
          <Route path="/wedding-dresses-in-motion" element={<WeddingDressesPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
